import { TreeOptionData } from 'tdesign-react/es/cascader/interface';
import { IRealNameVerify } from 'common/components/RealNameVerify';
// import { AccountApi as CommonAccountApi } from 'common/api';
import CommonAccountApi from 'common/http/services/AccountApi';
import { AUTH_STATUS, AUTH_TYPE, IOcrSingleInfo, SMS_CODE_TYPE } from 'idpBase/Constants';
import { AccountApi } from 'idpBase/http';
import { TGlobalStore, TUpdateStore } from 'idpBase/store';
import { AUTH_METHOD, jobList, talentList, TCoreMaterial, TTipConfig } from '../constants/personal';

class InformationStore {
  public readonly global: TGlobalStore;
  public updateStore: TUpdateStore<InformationStore>;
  public resetStore: () => void;

  public authInfo = {};

  public isSaveLoading = false;

  // 人脸识别组件
  public realNameVerifyRef = React.createRef<IRealNameVerify>();

  public certTypes: TreeOptionData[] = [];

  // 信息填写页的联动信息
  public tipInfo: TTipConfig;
  /** 职业认证需要进行认证身份类型选择 */
  public tipConfig: TTipConfig[];
  // 未认证用户的job_certify_id为空，首次保存草稿数据是返回的job_certify_id将作为用户的认证id并不变
  // 因此需要再获取草稿信息是进行保存，并在保存草稿数据时进行更新
  public job_certify_id = '';
  /** 图片材料 */
  public materialMap: Map<AUTH_METHOD, { core_materials: TCoreMaterial; external_link: string }> =
    new Map();

  // 微信OCR信息中手机号是否和会议手机号一致
  public isLoginPhone = false;
  // 微信OCR信息
  public wechatOcrInfo: IOcrSingleInfo[] = [];

  // 是否要跳转到结果页
  public get shouldGotoResult() {
    const status = m.get(this.authInfo, 'certify_base.status');
    return typeof status === 'number' && status !== AUTH_STATUS.INIT;
  }

  /**
   * 获取认证信息
   */
  public async getAuthInfo(authType: AUTH_TYPE) {
    const authInfo = await AccountApi.getAuthInfo(authType);
    if (!m.get(authInfo, 'errCode')) {
      this.updateStore({
        job_certify_id: m.get(authInfo, 'certify_base.job_certify_id'),
        authInfo,
        isLoginPhone: m.get(authInfo, 'certify_user_info.material_mobile_same_login'),
        wechatOcrInfo: m.get(authInfo, 'certify_materials.core_materials.0.url_list.0.ocr_info'),
      });
      // 保存材料信息
      this.materialMap.set(m.get(authInfo, 'certify_materials.material_resource_type'), {
        core_materials: m.get(authInfo, 'certify_materials.core_materials'),
        external_link: m.get(authInfo, 'certify_materials.external_link'),
      });
      return authInfo;
    }
    return;
  }

  /**
   * 发送手机验证码
   * @param phone 手机号
   * @param event 验证码对应的事件
   * @returns {Promise}
   */
  public async getSmsCode(sms_code_type: SMS_CODE_TYPE, certify_type: AUTH_TYPE) {
    const res = await AccountApi.sendSmsCode(sms_code_type, certify_type, this.job_certify_id);
    if (!m.get(res, 'errCode')) {
      return res;
    }
    return;
  }

  /**
   * 保存验证信息
   * @param params
   * @returns
   */
  public async save(params: Record<string, any>) {
    this.isSaveLoading = true;
    const res = await AccountApi.saveAuthInfo(params);
    this.updateStore({
      isSaveLoading: false,
    });
    if (!m.get(res, 'errCode')) {
      this.updateStore({
        job_certify_id: res.job_certify_id,
      });
      return true;
    }
    return false;
  }

  /**
   * 图片上传，分三步
   * 1. 获取token
   * 2. 图片带上token上传到cos桶
   * 3. 获取图片的临时链接
   */
  public uploadImg(img: File, upload_resource: string) {
    return CommonAccountApi.uploadImg({
      job_certify_id: this.job_certify_id,
      upload_resource,
      img,
    });
  }

  // 获取职业信息
  getCareerInfo(authType: AUTH_TYPE) {
    switch (authType) {
      case AUTH_TYPE.OCCUPATION:
        return jobList;
      case AUTH_TYPE.KOL:
        return talentList;
      default:
        return [];
    }
  }

  public async getCertTypes(authType: AUTH_TYPE) {
    const dataList = this.getCareerInfo(authType);
    function loopMap(arr: TreeOptionData[]): TreeOptionData[] {
      return (
        arr.map?.((item: TreeOptionData) => ({
          ...item,
          value: item.name,
          label: item.name,
          children: _.isArray(item.children) ? loopMap(item.children) : [],
        })) || []
      );
    }
    this.updateStore({
      certTypes: loopMap(dataList),
    });
  }

  /** OCR */
  public async getOcrInfo(cosId: string) {
    const ocrRes = await AccountApi.getOcr(cosId);
    if (m.get(ocrRes, 'errCode')) {
      return;
    }
    this.updateStore({
      isLoginPhone: ocrRes.is_login_phone,
      wechatOcrInfo: ocrRes.ocr_info,
    });
    return ocrRes.ocr_info;
  }
}

export default InformationStore;
